<template>
  <div class="dashboard-page-cont dashboard-myDataAssistant">
    <div class="dashboard-myDataAssistant-head">
      <span class="model-title">我的数据助手</span>
      <router-link class="model-more" :to="{name: 'dataAssistant'}">查看详情 <i class="el-icon-arrow-right"></i></router-link>
    </div>

    <div class="content-module-main">
      <div class="main-row" style="height: 337px;margin-bottom: 10px;">
        <!-- 登录频次   -->
        <div class="main-col">
          <LoginRate  />
        </div>
        <div class="main-space"></div>
        <!-- 询盘查看及分析数量趋势  -->
        <div class="main-col">
          <InquiryView />
        </div>
      </div>
      <div class="main-row" style="height: 337px">
        <!-- 用户访问趋势 -->
        <div class="main-col">
          <AccessTrend />
        </div>
        <div class="main-space"></div>
        <!-- 用户访问来源 -->
        <div class="main-col">
          <FileBrowsing  />
        </div>
      </div>
      <!-- <div class="main-row" style="min-height: 315px">
        <div class="main-col">
          授盘情况
          <AwardState
            ref="awardState"
            v-if="awardStateData"
            :dataCollection="awardStateData"
            :loading="awardStateLoading"
            @change="changeAfterDateType"
          />
        </div>
        <div class="main-space"></div>
        <div class="main-col">
          授盘方式占比
          <AwardRatio
            ref="awardRatio"
            v-if="awardRatioData"
            :dataCollection="awardRatioData"
            :loading="awardRatioLoading"
            @change="changeAfterDateType"
          />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import LoginRate from "./loginRate.vue";
import InquiryView from "./inquiryView.vue";
import AccessTrend from "./accessTrend.vue";
import FileBrowsing from "./fileBrowsing.vue";
export default {
  components: {
    LoginRate,
    InquiryView,
    AccessTrend,
    FileBrowsing
  },
  data() {
    return {
    }
  },
}
</script>


<style lang="scss">
.dashboard-myDataAssistant {
  background: #fff;
  padding: 20px 0 20px 20px;
  &-head {
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
    .model-more{
      margin-left: auto;
      height: 14px;
      line-height: 14px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #16181A;
      letter-spacing: 0;
    }
  }
  .content-module-main {
    .main-row {
      display: flex;
      flex-wrap: wrap;
      .main-col {
        // flex: 1;
        width: calc((100% - 42px) / 2);
        margin-bottom: 12px;
        background: #fff;
        border: 1px solid #eee;
        border-radius: 4px;
        .col-chart-box {
          .col-chart-head {
            height: 44px;
            line-height: 44px;
            // display: flex;
            // justify-content: space-between;
            padding: 0 25px 0 20px;
            align-items: center;
            // position: relative;
            .left {
              display: flex;
              // justify-content: center;
              // align-items: baseline;
              align-items: center;
              &-title{
                font-size: 12px;
                color: #16181A;
                font-weight: 600;
              }
              
              // h4 {
              //   height: 20px;
              //   line-height: 20px;
              //   font-family: PingFangSC-Regular;
              //   font-size: 14px;
              //   color: #333;
              //   flex-shrink: 0;
              // }
              i.icon-icon-zhuming2 {
                height: 14px;
                line-height: 14px;
                font-size: 14px;
                color: #999;
                margin-left: 10px;
              }
              .time {
                margin-left: 24px;
                // margin-left: 34px;
                // height: 12px;
                line-height: 12px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #999;
              }
            }
            .right {
              height: 28px;
              ul {
                display: flex;
                li {
                  width: 64px;
                  height: 24px;
                  box-sizing: border-box;
                  position: relative;
                  background: #fff;
                  margin-right: 10px;
                  font-family: PingFangSC-Regular;
                  line-height: 24px;
                  font-size: 12px;
                  color: #666;
                  text-align: center;
                  cursor: pointer;
                  border-radius: 4px;
                  transition: all 0.3s;
                  user-select: none;
                  border: 1px solid #eee;
                  &:nth-last-child(1) {
                    margin-right: 0;
                  }
                  &.active {
                    background: #1288db;
                    width: 64px;
                    height: 24px;
                    color: #fff;
                    cursor: auto;
                    border: 0;
                  }
                }
              }
            }
            // &.line {
            //   &::after {
            //     content: " ";
            //     display: block;
            //     position: absolute;
            //     height: 0;
            //     width: 100%;
            //     left: 0;
            //     bottom: 0;
            //     border-bottom: 1px solid #eee;
            //   }
            // }
          }
          .col-chart-view {
          }
        }
      }
      .main-space {
        width: 20px;
      }
    }
  }
  
}

</style>